import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oneuptime = defineConnector({
  identifier: "oneuptime",
  name: "OneUptime",
  tagLine: "Open source observability platform",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://oneuptime\\.com/.*",
  auth: (app) => headerAuth([{ name: "ApiKey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [OneUptime](https://oneuptime.com/), go to **Settings › API Keys** to generate a key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://oneuptime.com/api/status-page",
  },
});
